'use client'

import type { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'

import { isSpa } from '@/shared/env'

export function KitchenAuthLayout({ children }: { children?: ReactNode }) {
  const content = children ?? (isSpa ? <Outlet /> : null)
  return (
    <div className="min-h-screen bg-surface-container-low flex items-center justify-center p-gutter-tablet md:p-gutter-desktop antialiased">
      <div className="fixed inset-0 -z-10 pointer-events-none overflow-hidden">
        <div className="absolute -top-[10%] -right-[10%] w-[50%] h-[50%] bg-primary-container/10 rounded-full blur-3xl" />
        <div className="absolute -bottom-[5%] -left-[5%] w-[40%] h-[40%] bg-outline-variant/20 rounded-full blur-3xl" />
      </div>
      {content}
    </div>
  )
}
